/*
 * @Description: 
 * @Autor: pangting
 * @Date: 2024-12-12 17:09:06
 * @LastEditors: pangting
 * @LastEditTime: 2024-12-12 17:09:11
 */
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectTestFeedbackNewV4Api extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'project-test-feedback-new-v4'
    }

}